export { default } from "./NewsTags";
